export interface FaqItem {
  id: string;
  question: string;
  answer: string;
  category: string;
}

export const faqCategories = ["全部", "核验相关", "内容与来源", "使用与反馈"];

export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "棱镜求证主要做什么？",
    answer:
      "我们围绕社会爆料相关信息，聚合事件的反转进展、官方回应与辟谣结论，并用时间线的方式把事件全貌呈现出来。同时提供可复用的求证方法，帮助你在转发之前先做一次初步核验。",
    category: "核验相关",
  },
  {
    id: "faq-2",
    question: "你们给出的“核验结论”是最终定论吗？",
    answer:
      "不是。核验结论只代表我们在当前可获得材料基础上作出的判断，会随着官方通报、当事人说明等新信息持续更新。对于证据不足的信息，我们会标注为“存疑”或“待核验”，而不是勉强下结论。",
    category: "核验相关",
  },
  {
    id: "faq-3",
    question: "页面上的案例和时间线信息来自哪里？",
    answer:
      "主要来自可公开查证的材料，包括当事方的公开说明、主管部门通报以及媒体公开报道。每条案例下方都会列出参考来源，方便你自行核对。涉及隐私的可识别信息我们会做脱敏处理。",
    category: "内容与来源",
  },
  {
    id: "faq-4",
    question: "为什么有些爆料会出现“反转”？",
    answer:
      "信息在传播过程中常被裁剪、拼接或错置时间，最初的强烈情绪会让这些改动不易被察觉。当更完整的材料出现时，事件的走向就可能发生改变，这在核验中是很常见的现象。",
    category: "核验相关",
  },
  {
    id: "faq-5",
    question: "我可以提交线索或指出内容里的错误吗？",
    answer:
      "当然可以。你可以在“关于我们”页面通过线索提交表单联系我们，尽量附上可核实的公开来源。我们会认真核对每一条反馈，并在确认后更新相关内容。",
    category: "使用与反馈",
  },
  {
    id: "faq-6",
    question: "我发现信息可能不实，应该怎么做？",
    answer:
      "先不要转发。可以按照求证指南中的顺序做初步判断：找源头、对时间、查回应。在事实尚不清楚时，用“暂未确认”的表述向他人说明，往往比直接下结论更合适。",
    category: "使用与反馈",
  },
  {
    id: "faq-7",
    question: "内容多久更新一次？",
    answer:
      "进行中的事件我们会持续跟进，有新进展就会更新案例时间线。已经形成稳定结论的事件会保留存档，并在页面标注最近更新时间。",
    category: "内容与来源",
  },
  {
    id: "faq-8",
    question: "引用你们的核验结论需要注意什么？",
    answer:
      "欢迎引用，但请保留原始来源链接并注明结论对应的更新时间。核验结论具有时效性，脱离时间点的引用可能造成新的误读。",
    category: "内容与来源",
  },
];